import { render, staticRenderFns } from "./CultiveMaterial.vue?vue&type=template&id=6cc485cf"
import script from "./CultiveMaterial.vue?vue&type=script&lang=js"
export * from "./CultiveMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports